import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Highlight } from '../Highlight/Highlight.js';
import { item, label, textLabel } from './styles.js';
import { useTheme } from '../../theming/useTheme.js';
import { IconCheck } from '../../../icons/ui_control/IconCheck.web.js';
import { spacing } from '../../../constants/spacing.js';

function ListItem(props) {
  var children = props.children;
  props.disabled;
  var highlightValue = props.highlightValue;
  props.name;
  props.onClick;

  var onSelect = props.onSelect,
      onMouseMove = props.onMouseMove,
      selected = props.selected,
      active = props.active,
      value = props.value,
      delay = props.delay,
      activeRef = props.activeRef,
      color = props.color,
      highlightSelected = props.highlightSelected,
      ariaMultiselectable = props['aria-multiselectable'],
      rest = _objectWithoutProperties(props, ["children", "disabled", "highlightValue", "name", "onClick", "onSelect", "onMouseMove", "selected", "active", "value", "delay", "activeRef", "color", "highlightSelected", "aria-multiselectable"]);

  var handleMouseMove = React.useCallback(function () {
    return onMouseMove(value);
  }, [onMouseMove, value]);
  var handleClick = React.useCallback(function () {
    onSelect(value);
  }, [onSelect, value, activeRef]);
  var theme = useTheme();
  var selectedHighlight = selected && highlightSelected;
  return (
    /*#__PURE__*/
    React.createElement(item, _extends({
      "data-test": "elemental-ListItems-".concat(value),
      delay: delay,
      onMouseMove: handleMouseMove,
      onClick: handleClick,
      active: active,
      selectedHighlight: selectedHighlight,
      ref: activeRef // according to spec this needs to be explicitly false if multiselectable, and true/undefined for single select
      ,
      "aria-selected": ariaMultiselectable ? Boolean(selected) : selected ? true : undefined,
      role: "option" // add label manually as mark element in higlight is screen-read as two separate words
      ,
      "aria-label": // istanbul ignore next
      typeof children === 'string' ? "".concat(selected ? '✓' : '', " ").concat(children) : undefined,
      color: color
    }, rest),
    /*#__PURE__*/
    React.createElement(label, {
      color: color
    },
    /*#__PURE__*/
    React.createElement(textLabel, {
      highlight: typeof highlightValue === 'string',
      whiteSpace: theme.listItems.web.whiteSpace,
      color: color
    },
    /*#__PURE__*/
    React.createElement(Highlight, {
      search: highlightValue
    }, children)), selectedHighlight &&
    /*#__PURE__*/
    React.createElement(IconCheck, {
      marginLeft: "auto",
      marginRight: spacing.xxs,
      color: theme.listItems.web.textColor
    })))
  );
}

export { ListItem };